import { registerLicense } from '../../misc/Certificates/LicenseRegistry.js';
/**
 * License for giving somebody else access to all versions of data.
 */
export const AccessVersionedObjectLicense = Object.freeze({
    $type$: 'License',
    name: 'AccessVersionedObject',
    description: '[signature.issuer] gives permission to share all versions of [data] with [person].'
});
registerLicense(AccessVersionedObjectLicense, 'AccessVersionedObjectCertificate');
export const AccessVersionedObjectCertificateRecipe = {
    $type$: 'Recipe',
    name: 'AccessVersionedObjectCertificate',
    rule: [
        {
            itemprop: 'person',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['Person']) }
        },
        {
            itemprop: 'data',
            itemtype: { type: 'referenceToId', allowedTypes: new Set(['*']) }
        },
        {
            itemprop: 'license',
            itemtype: { type: 'referenceToObj', allowedTypes: new Set(['License']) }
        }
    ]
};
export const AccessVersionedObjectCertificateReverseMap = [
    'AccessVersionedObjectCertificate',
    new Set(['*'])
];
//# sourceMappingURL=AccessVersionedObjectCertificate.js.map